/**
 * Helpers for FileUpload row shapes used in project form state (`imageUrl` rows, etc.).
 */

export function fileItemUrl(item) {
  if (!item) return "";
  if (typeof item.file === "string") return item.file;
  if (item.url) return item.url;
  return "";
}

export function uploadItemHasUrl(item) {
  return Boolean(String(fileItemUrl(item)).trim());
}

export function isFileObject(value) {
  return typeof File !== "undefined" && value instanceof File;
}

/** Row has a local `File` (or similar) and no uploaded URL yet. */
export function uploadItemHasLocalFileOnly(item) {
  if (!item?.file || typeof item.file === "string") return false;
  return isFileObject(item.file);
}

export function uploadItemIsUploading(item) {
  return item?.status === "uploading";
}

export function uploadRowNeedsUpload(item) {
  return uploadItemHasLocalFileOnly(item) || uploadItemIsUploading(item);
}
